export type APILibraryVerticalResponseType = Partial<{
  id: number;
  url: string;
  code: string;
  name: string;
  status: "active" | "disabled";
  is_system: boolean;
  created: string;
  modified: string;
}>;
export type APILibraryVerticalRequestType = Pick<
  Required<APILibraryVerticalResponseType>,
  "code" | "name" | "status"
>;
export interface IAPILibraryVertical {
  toRequestModel(): APILibraryVerticalRequestType;
  isDataValid(): boolean;
  getData(): APILibraryVerticalResponseType;
}

export class APILibraryVertical implements IAPILibraryVertical {
  readonly data: APILibraryVerticalResponseType;
  constructor(data: APILibraryVerticalResponseType) {
    this.data = data;
  }
  getData(): APILibraryVerticalResponseType {
    return this.data;
  }
  isDataValid(): boolean {
    return !!this.data.name && !!this.data.code;
  }
  toRequestModel(): APILibraryVerticalRequestType {
    if (this.isDataValid()) {
      return {
        code: this.data.code!.toUpperCase(),
        name: this.data.name!.trim(),
        status: this.data.status ?? "active",
      };
    }
    throw new Error("Invalid data: name or code is required");
  }
}
